import { render, staticRenderFns } from "./MetaField.vue?vue&type=template&id=b3b34b4e&scoped=true&"
import script from "./MetaField.vue?vue&type=script&lang=js&"
export * from "./MetaField.vue?vue&type=script&lang=js&"
import style0 from "./MetaField.vue?vue&type=style&index=0&id=b3b34b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b34b4e",
  null
  
)

export default component.exports